// Reine Rechenfunktionen der neuen Produktseite (hy-main-product). Beträge in Cent, Zeiten in Millisekunden.

const MS_PER_MINUTE = 60 * 1000;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;

export function lineTotalCents(unitCents, qty) {
  return unitCents * qty;
}

export function remainingForFreeShipping(thresholdCents, cartTotalCents, addCents) {
  return Math.max(0, thresholdCents - cartTotalCents - addCents);
}

export function freeShippingProgress(thresholdCents, cartTotalCents, addCents) {
  if (thresholdCents <= 0) return 1;
  return Math.min(1, Math.max(0, (cartTotalCents + addCents) / thresholdCents));
}

// Warenkorbwert für den Gratisversand wie in snippets/hy-pdp-buy.liquid: versandpflichtige Positionen minus Warenkorbrabatte.
export function shippableCartTotalCents(cart) {
  const lines = cart.items.filter((item) => item.requires_shipping).reduce((sum, item) => sum + item.final_line_price, 0);
  const discounts = (cart.cart_level_discount_applications || []).reduce((sum, discount) => sum + discount.total_allocated_amount, 0);
  return lines - discounts;
}

export function variantQuantityInCart(cart, variantId) {
  return cart.items.filter((item) => String(item.variant_id) === String(variantId)).reduce((sum, item) => sum + item.quantity, 0);
}

export function isPromoActive(nowMs, startMs, endMs) {
  if (startMs != null && nowMs < startMs) return false;
  if (endMs != null && nowMs >= endMs) return false;
  return true;
}

const pad = (value) => String(value).padStart(2, '0');

export function formatCountdown(msLeft) {
  if (msLeft <= 0) return '00:00:00';
  const totalMinutes = Math.floor(msLeft / MS_PER_MINUTE);
  const minutes = totalMinutes % MINUTES_PER_HOUR;
  const totalHours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
  const hours = totalHours % HOURS_PER_DAY;
  const days = Math.floor(totalHours / HOURS_PER_DAY);
  return `${pad(days)}:${pad(hours)}:${pad(minutes)}`;
}
